import { render, staticRenderFns } from "./UniversalUserListBox.vue?vue&type=template&id=107bfe68&"
import script from "./UniversalUserListBox.vue?vue&type=script&lang=ts&"
export * from "./UniversalUserListBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports